export default __webpack_public_path__ + "static/media/productbg.7e0e1208.jpg";